import React from 'react';
import faqData from './faqData';

const FAQ = () => {
  // Split the FAQ data into two equal parts for two columns
  const midpoint = Math.ceil(faqData.length / 2);
  const leftColumnFAQs = faqData.slice(0, midpoint);
  const rightColumnFAQs = faqData.slice(midpoint);

  // Function to render HTML content safely
  const createMarkup = (htmlContent) => {
    return { __html: htmlContent };
  };

  return (
    <div className="sicknote-faq">
      <div className="row">
        <div className="col-xl-10 offset-xl-1 col-lg-10 offset-lg-1">
          <div className="section-title text-center pos-rel mb-75">
            <div className="section-icon">
              {/* Existing code */}
            </div>
            <div className="section-text pos-rel">
              <h5>Frequently asked questions</h5>
              <h2>FAQs</h2>
            </div>
            <div className="section-line pos-rel">
              <img src="img/shape/section-title-line.png" alt="" />
            </div>
          </div>
        </div>
      </div>

      <div className="sicknote-faq-container">
        <div className="row py-2">
          <div className="col-lg-12">
            <div id="bootstrap-accordion_13" className="panel-group accordionStyles accordion" role="tablist"
              aria-multiselectable="true">
              <div className="row">
                <div className="col-lg-6">
                  {leftColumnFAQs.map((faq, index) => (
                    <div className="card" key={faq.id}>
                      <div className="card-header" role="tab" id={`heading${faq.id}`}>
                        <a role="button" className="panel-title collapsed pr-5 text-black" data-toggle="collapse"
                          data-core="" href={`#collapse${faq.id}`} aria-expanded="false" aria-controls="collapse1">
                          <h4 className="mbr-fonts-style display-7">{`${index + 1}. ${faq.question}`}
                            <div><span className="toggle-icon inactive sign mbr-iconfont"></span>
                            </div>
                          </h4>
                        </a>
                      </div>
                      <div id={`collapse${faq.id}`} className="panel-collapse noScroll collapse " role="tabpanel"
                        aria-labelledby={`heading${faq.id}`} data-parent="#bootstrap-accordion_13">
                        <div className="panel-body">
                          <p className="mbr-fonts-style panel-text display-4" 
                             dangerouslySetInnerHTML={createMarkup(faq.answer)}>
                          </p>
                          {faq.hasBadge && (
                            <div className="text-center mt-3">
                              <img 
                                src="img/badge/Doctor-PIPA.png" 
                                alt="PIPA Compliant - Personal Information Protection Act" 
                                width="180" 
                                className="img-fluid" 
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="col-lg-6">
                  {rightColumnFAQs.map((faq, index) => (
                    <div className="card" key={faq.id}>
                      <div className="card-header" role="tab" id={`heading${faq.id}`}>
                        <a role="button" className="panel-title collapsed pr-5 text-black" data-toggle="collapse"
                          data-core="" href={`#collapse${faq.id}`} aria-expanded="false" aria-controls="collapse1">
                          <h4 className="mbr-fonts-style display-7">{`${index + leftColumnFAQs.length + 1}. ${faq.question}`}
                            <div><span className="toggle-icon inactive sign mbr-iconfont"></span>
                            </div>
                          </h4>
                        </a>
                      </div>
                      <div id={`collapse${faq.id}`} className="panel-collapse noScroll collapse " role="tabpanel"
                        aria-labelledby={`heading${faq.id}`} data-parent="#bootstrap-accordion_13">
                        <div className="panel-body">
                          <p className="mbr-fonts-style panel-text display-4"
                             dangerouslySetInnerHTML={createMarkup(faq.answer)}>
                          </p>
                          {faq.hasBadge && (
                            <div className="text-center mt-3">
                              <img 
                                src="img/badge/Doctor-PIPA.png" 
                                alt="PIPA Compliant - Personal Information Protection Act" 
                                width="180" 
                                className="img-fluid" 
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;